import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../../features/auth/authSlice';
import { getInspectionAccessUrl, redirectToInspection } from '../../../utils/inspectionAccess';
import showToast from '../../../components/Toast';

export default function useInspectorAccess() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return () => {
    const token = localStorage.getItem('token');
    if (!token?.trim()) {
      dispatch(logout());
      navigate('/login', { replace: true });
      return;
    }
    let url;
    try { url = getInspectionAccessUrl(token); }
    catch {
      showToast('error', 'Inspector access is unavailable. Please check the inspection application URL.');
      return;
    }
    dispatch(logout());
    redirectToInspection(url);
  };
}
